import styled from "styled-components";
import Box from "../Box";

const AutocompleteMenu = styled(Box).attrs({
  borderRadius: "default",
  position: "absolute",
  top: "100%",
  zIndex: 1,
  width: "100%",
  background: "white",
  border: "default",
  borderTop: "none",
  boxShadow: "panel",
})``;

const Item = styled(Box).attrs<{ isActive?: boolean }>(props => {
  return {
    p: "xs",
    mx: "xs",
    borderRadius: "default",
    background: props.isActive ? "grayLightest" : "none",
  };
})<{ isActive?: boolean }>``;

const Divider = styled(Box).attrs({
  height: "4px",
  background: "grayLightest",
})``;

type AutocompleteMenuComponent = typeof AutocompleteMenu & {
  Item: typeof Item;
  Divider: typeof Divider;
};

const Component = AutocompleteMenu as AutocompleteMenuComponent;
Component.Item = Item;
Component.Divider = Divider;

export default Component;
